var _excluded = ["padding", "paddingVertical", "paddingHorizontal", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight"];
var _templateObject;
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React from "react";
import styled from "styled-components";
import { focusOutlineColor, focusOutlineStyle, focusOutlineWidth } from "@nib-components/theme";
import { paddings, spacingPropTypeMap } from "@nib/layout";
export var UnstyledButton = styled(function (_ref) {
  var padding = _ref.padding,
    paddingVertical = _ref.paddingVertical,
    paddingHorizontal = _ref.paddingHorizontal,
    paddingTop = _ref.paddingTop,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingRight = _ref.paddingRight,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  appearance: none;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  line-height: 1;\n  color: currentColor;\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: -", ";\n  }\n  ", ";\n"])), focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineWidth, function (props) {
  return paddings(props);
});
export default UnstyledButton;
UnstyledButton.displayName = "UnstyledButton";